export const getFactPDF = (idF, hash) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();
    var formdata = new FormData();
    myHeaders.append("Authorization", `Bearer ${localStorage.getItem("ContaKMPCot")}`)
    formdata.append("id", idF);
    formdata.append("hash", hash);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/FacturaPDF`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}

export const getTransferencia = (idP, hash) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();
    var formdata = new FormData();
    myHeaders.append("Authorization", `Bearer ${localStorage.getItem("ContaKMPCot")}`)
    formdata.append("id", idP);
    formdata.append("hash", hash);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/getTransferencia`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}

export const getPay = (idF, hash) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();
    var formdata = new FormData();
    myHeaders.append("Authorization", `Bearer ${localStorage.getItem("ContaKMPCot")}`)
    formdata.append("id", idF);
    formdata.append("hash", hash);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/TransferenciaComp`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}